import React from 'react';
import './Impressum.css';

const Impressum = () => {
  return (
    <div className="impressum-container">
      <h1>Impressum</h1>

      <section className="impressum-section">
        <h2>Angaben gemäß § 5 DDG</h2>
        <div className="company-details-box">
          <p><strong>SaveMove Umzüge</strong></p>
          <p>Inhaber: Hasan Al Mohamad</p>
          <p>Am Sandhaus 31</p>
          <p>13125 Berlin</p>
        </div>
      </section>

      <section className="impressum-section">
        <h2>Kontakt</h2>
        <p>
          Telefon: <a href="tel:+4917684572071">+49 176 845 720 71</a><br />
          E-Mail: <a href="mailto:info@savemove.de">info@savemove.de</a>
        </p>
      </section>

      <section className="impressum-section">
        <h2>Redaktionell verantwortlich</h2>
        <p>
          Hasan Al Mohamad<br />
          Am Sandhaus 31<br />
          13125 Berlin
        </p>
      </section>

      <section className="impressum-section">
        <h2>EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr/
          </a>.<br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </section>

      <section className="impressum-section">
        <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </div>
  );
};

export default Impressum;